import React, { useMemo } from 'react'

import { IBTestSubCategory } from '@model/TestSectionsDto'

import { IBDefaultCarousel } from './IBDefaultCarousel'
import { IBMultiTierCarousel } from './IBMultiTierCarousel'

import styles from './IBCarousel.module.scss'

interface Props {
  subCategoryId?: IBTestSubCategory
}

export const IBCarousel: React.FC<Props> = ({ subCategoryId }) => {
  const innerComponent = useMemo(() => {
    switch (subCategoryId) {
      case IBTestSubCategory.MultiTier:
        return <IBMultiTierCarousel />
      case IBTestSubCategory.Default:
      default:
        return <IBDefaultCarousel />
    }
  }, [subCategoryId])

  return <div className={styles.carouselWrapper}>{innerComponent}</div>
}
